// extracted by css-extract-rspack-plugin
export default {"cls1":"create_work_collection_modal-wjs-cls1_506","cls2":"create_work_collection_modal-wjs-cls2_lz_ create_work_collection_modal-wjs-cls1_506"};